import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "brain_break_id": {
      "column": {
        "default": null,
        "name": "brain_break_id",
        "null": false,
        "type": null
      },
      "name": "brain_break_id",
      "selected_by_default": null,
      "translated": null
    },
    "class_step_id": {
      "column": {
        "default": null,
        "name": "class_step_id",
        "null": false,
        "type": null
      },
      "name": "class_step_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "BrainBreakClassStep",
  "collectionKey": "brain_break_class_steps",
  "collectionName": "brain_break_class_steps",
  "i18nKey": "brain_break_class_step",
  "camelizedLower": "brainBreakClassStep",
  "name": "BrainBreakClassStep",
  "nameDasherized": "brain-break-class-step",
  "pluralName": "brain_break_class_steps",
  "ransackable_associations": [
    {
      "className": "BrainBreakClassStep::Audit",
      "collectionName": "brain_break_class_step_audits",
      "foreignKey": "brain_break_class_step_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "BrainBreakClassStepAudit",
      "through": null
    },
    {
      "className": "BrainBreak",
      "collectionName": "brain_breaks",
      "foreignKey": "brain_break_id",
      "name": "brain_break",
      "macro": "belongs_to",
      "resource_name": "BrainBreak",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "belongs_to",
      "resource_name": "ClassStep",
      "through": null
    },
    {
      "className": "BrainBreakClassStep::Audit",
      "collectionName": "brain_break_class_step_audits",
      "foreignKey": "brain_break_class_step_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "BrainBreakClassStepAudit",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "brain_break_id",
      "column": {
        "default": null,
        "name": "brain_break_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "class_step_id",
      "column": {
        "default": null,
        "name": "class_step_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "BrainBreak",
      "collectionName": "brain_breaks",
      "foreignKey": "brain_break_id",
      "name": "brain_break",
      "macro": "belongs_to",
      "resource_name": "BrainBreak",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "belongs_to",
      "resource_name": "ClassStep",
      "through": null
    }
  ],
  "paramKey": "brain_break_class_step",
  "primaryKey": "id"
}

/** Frontend model for BrainBreakClassStep. */
class BrainBreakClassStep extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  brainBreakId() {
    return this.readAttributeUnderscore("brain_break_id")
  }

  /** @returns {boolean} */
  hasBrainBreakId() {
    const value = this.brainBreakId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  classStepId() {
    return this.readAttributeUnderscore("class_step_id")
  }

  /** @returns {boolean} */
  hasClassStepId() {
    const value = this.classStepId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./brain-break.js").default | null} */
  brainBreak() {
    return this._readBelongsToReflection({reflectionName: "brain_break"})
  }

  /** @returns {Promise<import("./brain-break.js").default | null>} */
  loadBrainBreak() {
    if (!("brainBreakId" in this)) throw new Error("Foreign key method wasn't defined: brainBreakId")

    const id = this.brainBreakId()
    const modelClass = modelClassRequire("BrainBreak")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "brain_break", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./class-step.js").default | null} */
  classStep() {
    return this._readBelongsToReflection({reflectionName: "class_step"})
  }

  /** @returns {Promise<import("./class-step.js").default | null>} */
  loadClassStep() {
    if (!("classStepId" in this)) throw new Error("Foreign key method wasn't defined: classStepId")

    const id = this.classStepId()
    const modelClass = modelClassRequire("ClassStep")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "class_step", model: this, modelClass},
      {ransack}
    )
  }
}

export default BrainBreakClassStep
